export class AccountResponse {
	id: number;
	accountNumber: number;
	bank: number;
	bankAccountType: number;
	balance: number;
	currency: number;
	company: number;
	alias: string;
	active: boolean;
	account4: number;
	withInitialBalance: boolean;
	international: boolean;
	//for frontend
	allMoves!: MoveAccountResponse[];
	filteredMoves!: MoveAccountResponse[];
	bankName!: string;
	initialBalance!: number;

	constructor() {

	}
}

export class AccountLevel4Response {
	id: number;
	displayId: string;
	name: string;
	balance: number;
	deletable: boolean;
	constructor() {

	}
}

export class AccountOptionResponse {
	bankAccountTypes: BankAccountTypesResponse[] = [];
	currencies: CurrenciesResponse[] = [];
	erpBanks: ErpBankResponse[] = [];

	constructor() {

	}
}

export class BankAccountTypesResponse {
	description: string;
	id: number;
	name: string;

	constructor() {

	}
}

export class CurrenciesResponse {
	id: number;
	name: string;
	symbol: string;
	exchangeRate: number;

	constructor() {

	}
}

export class ErpBankResponse {
	accountNumber: string;
	deposit: boolean;
	id: number;
	name: string;
	value: string;

	constructor() {

	}
}

export class MoveAccountResponse {
	balance: number;
	beneficiary: string;
	creationDate: number;
	date: number;
	description: string;
	docNumber: string;
	incoming: number;
	outcoming: number;
}